import { Button, Grid, TextField, Typography } from '@mui/material';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getDataAsync } from '../../app/firebase';
import { loginUser } from '../../features/user/UserSlice';
import Spacer from '../common/Spacer';

const Login = () =>
{
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogin = async (e) =>
    {
        e.preventDefault();

        const auth = getAuth();
        try
        {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            getDataAsync('/users/' + user.uid, handleGetUserData);
        } catch (error)
        {
            setError(error.message); // Show error message if something went wrong
        }
    };

    const handleGetUserData = (user) =>
    {
        dispatch(loginUser(user));
        navigate('/');
    }

    return (
        <Grid container direction="column" justify="center" alignItems="center" style={{ height: '100vh' }}>
            <Spacer height={40} />
            <Spacer height={40} />
            <Typography>Molimo Vas da se ulogujete 2</Typography>
            <Spacer />
            {error && <p>{error}</p>}
            <form onSubmit={handleLogin}>
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    autoFocus
                />
                <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="Šifra"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                />
                <Spacer />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                >
                    Nastavi
                </Button>
            </form>
            <Spacer height={60} />
        </Grid>
    );
};

export default Login;
